// extracted by mini-css-extract-plugin
module.exports = {"faq":"GZ7VDbSQ","title":"LpqlCw93"};